export default __webpack_public_path__ + "static/media/botanic_edit.7788ca59.jpg";